import { getSearchSessionPrefix, searchSessionKey } from "./searchSessionStorage";

const CACHE_NAME = "recommendationsPage_v1";

/**
 * In-memory cache keyed by the same prefix as sessionStorage.
 * Survives React route changes in the same tab with zero latency (no parse/stringify).
 */
const memoryByPrefix = new Map();

function rememberInMemory(prefix, payload) {
  memoryByPrefix.set(prefix, payload);
}

function readFromMemory(prefix) {
  const data = memoryByPrefix.get(prefix);
  if (!data || !Array.isArray(data.recommendations) || !data.recommendations.length) {
    return null;
  }
  return data;
}

export function readRecommendationsPageCache() {
  const prefix = getSearchSessionPrefix();
  const mem = readFromMemory(prefix);
  if (mem) return mem;

  try {
    const raw = sessionStorage.getItem(searchSessionKey(CACHE_NAME));
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data || !Array.isArray(data.recommendations)) return null;
    return data;
  } catch {
    return null;
  }
}

/**
 * Snapshot for restoring Recommendations on first paint (avoids full-page "Loading…"
 * when navigating back from Saved, etc.). Only for signed-in users; guest mode uses its own flow.
 */
export function getAuthRecommendationsCacheSnapshot(guestPreview) {
  if (guestPreview) return null;
  if (typeof window === "undefined" || !localStorage.getItem("authToken")) {
    return null;
  }
  const cached = readRecommendationsPageCache();
  if (!cached?.recommendations?.length) return null;
  return {
    recommendations: cached.recommendations,
    interestedProfessors: new Set(cached.interestedProfessors || []),
    savedProfessors: new Set(cached.savedProfessors || []),
    recentProfessorIds: cached.recentProfessorIds || [],
    scrollY: typeof cached.scrollY === "number" ? cached.scrollY : null,
  };
}

export function writeRecommendationsPageCache(payload) {
  const prefix = getSearchSessionPrefix();
  rememberInMemory(prefix, payload);
  try {
    sessionStorage.setItem(
      searchSessionKey(CACHE_NAME),
      JSON.stringify(payload)
    );
  } catch (e) {
    console.warn("recommendations cache write failed", e);
  }
}

export function clearRecommendationsPageCache() {
  try {
    memoryByPrefix.clear();
    sessionStorage.removeItem(searchSessionKey(CACHE_NAME));
  } catch {
    /* ignore */
  }
}
